<template>
  <div>
    <tabs>
      <tab name="Profil" :selected="true">
        <div class="py-4 text-left">
          <div class="float-right">
            <div v-if="user.id">
              <router-link :to="{ name: 'edit-profile', params: { id: user.id } }">
                <span class="p-2">
                  <i class="fa fa-edit"></i>
                </span>
              </router-link>
            </div>
          </div>
          <div class="py-1">
            <h3 class="font-semibold">
              {{ $t('Name')}}:
              <span>{{ user.name}}</span>
            </h3>
          </div>
          <div class="py-1">
            <h3 class="font-semibold">
              {{ $t('Email')}}:
              <span>{{ user.email}}</span>
            </h3>
          </div>
          <div class="py-1">
            <p class="font-semibold">
              {{ $t('About')}}:
              <span>{{ user.about }}</span>
            </p>
          </div>
          <div class="py-1">
            <h3 class="font-semibold">
              {{ $t('PhoneNumber')}}
              <span>{{ user.phone}}</span>
            </h3>
          </div>
          <div class="py-1">
            <router-link
              class="bg-teal-400 text-white p-1 rounded hover:bg-white hover:text-teal-400"
              to="/change-pwd"
            >{{ $t('ChangePassword')}}</router-link>
          </div>
        </div>
      </tab>
      <tab name="Adresse">
        <Address />
      </tab>
      <tab name="Bestellung">
        <Orders />
      </tab>
    </tabs>
  </div>
</template>

<script>
import axios from "axios";
import Tabs from "./Tabs";
import Tab from "./Tab";
import Address from "./Address";
import Orders from "./Orders";

export default {
  components: {
    Tabs,
    Tab,
    Address,
    Orders
  },
  data() {
    return {
      user: {},
      id: this.$route.params.id,
      image: null
    };
  },
  created() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    axios.get(`${process.env.VUE_APP_API}/user`).then(response => {
      this.user = response.data.data;
    });
  }
  // methods: {
  //   onFileChange(event) {
  //     this.image = event.target.files[0];
  //   },

  //   updateProfile() {
  //     axios.defaults.headers.common["Authorization"] =
  //       "Bearer " + localStorage.getItem("access_token");

  //     // let formData = new FormData();
  //     // formData.append("image", this.image, this.image);

  //     axios
  //       .put(`${process.env.VUE_APP_API}/profile`, {
  //         name: this.user.name,
  //         about: this.user.about,
  //         phone: this.user.phone
  //         // formData
  //       })
  //       .then(
  //         this.$notify({
  //           group: "profile",
  //           title: "Profile",
  //           text: "Profil Profilaktualisierung"
  //         })
  //       )
  //       .catch(error => console.log(error));
  //   }
  // }
};
</script>

<style></style>
